<template>
  <div class="gift" v-if="giftLsit">
    <!-- 导航栏 -->
    <van-nav-bar title="礼包中心" :fixed="true" :placeholder="true" />
    <!-- 礼包分类列表 -->
    <div class="gift-wrapper">
      <!-- 独家礼包 -->
      <div class="gift-block" v-for="(gItem,index) in giftLsit" :key="index">
        <div class="title-bar">
          <span class="gift-title">{{gItem.title}}</span>
          <router-link
            tag="span"
            :to="{path:'/gift/moregift',query:{id:gItem.gift_type_id}}"
            class="more"
          >更多礼包</router-link>
        </div>
        <div class="game-list">
          <router-link
            tag="div"
            :to="{name:'giftDetails',query:{id:item.gift_id}}"
            class="game-block"
            v-for="(item,index) in gItem.gifts"
            :key="index"
          >
            <div class="i-game">
              <img v-lazy="item.icon_url" />
            </div>
            <div class="des">
              <p class="game-name">{{item.game_name}}</p>
              <p class="gift-name">{{item.title}}</p>
              <p class="gift-num">剩余:{{item.keep_num}}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { contTools } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "@/assets/js/until";
export default {
  name: "gift",
  mixins: [contTools],
  components: {},
  data() {
    return {
      giftLsit: []
    };
  },
  watch: {},
  computed: {},
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      let data = comTools.assignObj(this.wapConfig(), {});
      data.sign = comTools.querySort(data);
      wapApiFun.giftList(data).then(res => {
        if (res.code == 200) {
          this.giftLsit = res.data;
        } else {
          this.$toast("网路出错");
        }
        console.log("礼包", res);
      });
    }
  }
};
</script>
<style lang='less' scoped>
@import "~@/assets/css/com.less";
.gift {
  width: 100%;
  padding-bottom: 3rem;
  background-color: #f9f9f9;
  .gift-wrapper {
    .gift-block {
      background-color: #fff;
      .borderRadius();
      .boxShadow(1px);
      width: 92%;
      margin: 0 auto;
      margin-bottom: 0.5rem;
      padding-top: 0.3rem;
      &:first-child {
        margin-top: 0.5rem;
      }
      .title-bar {
        width: 95%;
        height: 100%;
        margin: 0 auto;
        margin-bottom: 10px;
        .jc-between();
        position: relative;
        .gift-title {
          padding-left: 0.3rem;
          &::before {
            content: "";
            // height: .5rem;
            height: 75%;
            .theme-bg-color();
            width: 2px;
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translate(0, -50%);
          }
        }
        .more {
          font-size: 0.4rem;
        }
      }
      .game-list {
        width: 95%;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        .game-block {
          display: flex;
          width: 50%;
          margin-bottom: 0.5rem;
          .i-game {
            width: 1.8rem;
            img {
              .img();
            }
          }
          .des {
            width: 50%;
            margin-left: 0.35rem;
            .game-name {
              width: 100%;
              .ellipsis();
            }
            .gift-name,
            .gift-num {
              .font-color();
              font-size: 0.3rem;
              width: 85%;
              .ellipsis();
            }
            .gift-num {
              .theme-color();
            }
          }
        }
      }
    }
  }
}
</style>